import { Component } from '@angular/core';

@Component({
  selector: 'app-unique-chart',
  template: `<app-chart-output></app-chart-output>`,
  styleUrls: []
})
export class UniqueChartComponent {

}
